import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/riscossioni/Riscossioni.vue'),
		meta: {
			title: 'offers',
			acl: 'section.riscossioni'
		}
	}
];

export default routes;